import NanoEvent from 'nanoevents';

const events = new NanoEvent();

export default class EventGroup {
    event = '';
    handleEvent = () => {};
    afterEvent = () => {};

    constructor(event, handleEventFn, afterEventFn) {
        this.event = event;
        if (handleEventFn) {
            this.handleEvent = handleEventFn;
        }
        if (afterEventFn) {
            this.afterEvent = afterEventFn;
        }
    }

    async emit(...args) {
        const data = this.handleEvent(...args);
        if (data === false) {
            // shortcut if we don't want to actually fire the event
            return;
        }
        args = data || args;
        events.emit(this.event, ...args);
        this.afterEvent(...args);
        console.debug('emitted event:', this.event);
    }

    listen(cb) {
        return events.on(this.event, cb);
    }
}
